export const daysList = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const formatOptionLabel = ({ label, code }) => (
  <div>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <span>{label}</span>
    </div>
    <span style={{ fontWeight: 600 }}>{code}</span>
  </div>
);

export const customFilterOption = (option, inputValue) => {
  const { label, code } = option.data;
  const search = inputValue.toLowerCase();

  return (
    label.toLowerCase().includes(search) || code?.toLowerCase().includes(search)
  );
};
